import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import AppIcon from '@/components/Base/AppIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppModalClose',
  emits: {
  close: null,
},
  setup(__props, { emit }) {



const modalClose = (): void => {
  emit('close');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "modal-handle-ignore translate-x-1 hover:brightness-150",
    onClick: modalClose
  }, [
    _createVNode(AppIcon, {
      src: require('@/assets/images/modal/modal-close.png'),
      class: "modal-handle-ignore h-[24px]"
    }, null, 8, ["src"])
  ]))
}
}

})